import React from 'react';
import SubEnterpriseChild from '../SubEnterpriseChild/SubEnterpriseChild';

const ChildEnterprise = () => <SubEnterpriseChild mode="child-only" />;

export default ChildEnterprise;
